import React, { useEffect, useState } from 'react';
export function HeroSection() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section className="relative w-full mt-[56px] md:mt-[60px] min-h-[300px] md:min-h-[400px] lg:min-h-[500px] flex items-center justify-center overflow-hidden" data-id="element-102">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat lg:bg-fixed" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1585435557343-3b092031a831?w=1600&q=80")'
    }} role="img" aria-label="Toddler arm showing subtle skin irritation with water droplets and morning bathroom light, representing the water quality challenge for sensitive skin" data-id="element-103">
        <div className="absolute inset-0 bg-gradient-to-b from-white/95 to-white/85" data-id="element-104" />
      </div>

      {/* Content Container */}
      <div className="relative z-10 w-full text-center" data-id="element-105">
        <div className="max-w-[900px] mx-auto px-5 pt-6 md:pt-8 pb-3" data-id="element-106">
          <div className="lg:bg-white/98 lg:p-8 lg:pb-4 lg:rounded-lg lg:shadow-sm" data-id="element-107">
            <h1 className={`text-[24px] md:text-[32px] lg:text-[48px] font-bold text-brand-teal leading-[1.3] tracking-[-0.5px] mb-0 drop-shadow-sm transition-all duration-800 ease-out ${mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{
            transitionDelay: '200ms'
          }} data-id="element-108">
              6 Ways Your Tap Water Is Damaging Your Toddler's Delicate Skin
              Barrier
            </h1>
          </div>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/5nEyyAe2CxDseMUnvGy3ZU/unnamed_(1).jpg" alt="Toddler's arm reaching under running bath water showing skin irritation" className={`w-full h-auto object-cover mb-6 transition-all duration-800 ease-out ${mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{
        transitionDelay: '300ms'
      }} data-id="element-109" />

        <div className="max-w-[900px] mx-auto px-5" data-id="element-110">
          <div className="lg:bg-white/98 lg:p-8 lg:rounded-lg lg:shadow-sm" data-id="element-111">
            <h2 className={`text-[16px] md:text-[18px] lg:text-[20px] font-semibold text-brand-navy leading-[1.5] mb-6 transition-all duration-800 ease-out ${mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{
            transitionDelay: '400ms'
          }} data-id="element-112">
              Australian parents are discovering something dermatologists rarely
              mention: the water in your shower is active chemical damage.
              Here's what's happening during every bath—and why you can't fix it
              with creams.
            </h2>

            <div className={`text-[16px] md:text-[16px] lg:text-[18px] font-normal text-brand-navy leading-[1.8] max-w-[700px] mx-auto space-y-4 transition-all duration-800 ease-out ${mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{
            transitionDelay: '600ms'
          }} data-id="element-113">
              
              
              <p data-id="element-114">
                Here are 6 specific ways this happens, and why{' '}
                <strong data-id="element-115">understanding them changes everything</strong>.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 animate-bounce-down text-brand-teal" data-id="element-116">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-117">
          <path d="M12 5v14" data-id="element-118" />
          <path d="m19 12-7 7-7-7" data-id="element-119" />
        </svg>
      </div>
    </section>;
}